<template>
  <span class="menu-divider" />
</template>

<script setup lang="ts"></script>

<style scoped lang="less">
.menu-divider {
  height: 1px;
  width: 1px;
  margin: auto 0;
  overflow: hidden;
  line-height: 0;
  background: rgba(11, 38, 64, 0.22);
}
</style>
